import { initMixpanel } from './init';
import * as events from './events';
import { identify } from './common';

export const analytics = {
  init: initMixpanel,
  events,
  identify,
};
